export class ViewApplicationGraveCmConstants {
    static STEP_TITLE = "Grave";
    static GRAVE_LABEL = "Selected grave";
    static CEMETERY_LABEL = "Cemetery name";
    static PLOT_NO_LABEL = "Plot number";
    static GRAVE_STATUS_LABEL = "Grave status";
    static CONDITION_LABEL = "Condition";
    static CAPACITY_LABEL = "Capacity";
    static MARKER_INSCRIPTION_LABEL = "Marker inscription";
    static MARKER_TYPE_LABEL = "Marker type";
    static GRAVE_FORM_CONTROL_NAME = "grave";
    static CEMETERY_FORM_CONTROL_NAME = "cemeteryName";
    static PLOT_NO_FORM_CONTROL_NAME = "plotNumber";
    static GRAVE_STATUS_FORM_CONTROL_NAME = "graveStatus";
    static CONDITION_FORM_CONTROL_NAME = "condition";
    static CAPACITY_FORM_CONTROL_NAME = "capacity";
    static MARKER_INSCRIPTION_FORM_CONTROL_NAME = "markerInscription";
    static MARKER_TYPE_FORM_CONTROL_NAME = "markerType";
    static INVALID_GRAVE_INFORMATION;
    static LOADING_GRAVE_INFORMATION;
    static INVALID_GRAVE_ID = "Invalid grave. Please select a new grave for the application.";
    static MULTIPLE_GRAVE_ID = "More than one grave has the same id. Please contact the system administrator.";
    static NO_GRAVE_LAYER_CONFIGURED = "No grave selection layer configured. Please contact the system administrator.";
    static NO_GRAVE_SELECTED = "No grave selected.";
    static NO_GRAVE_SELECTED_FOR_APPLICATION = "No grave has been selected for this application.";
    static NO_CEMETERY_LAYER_CONFIGURED = "No cemetery selection layer configured. Please contact the system administrator.";
    static NO_CEMETERY_LINKED_TO_GRAVE;
    static INVALID_CEMETERY_ID = "Invalid cemetery. Please contact the system administrator.";
    static MULTIPLE_CEMETERY_ID = "More than one cemeteries have the same id. Please contact the system administrator.";
}
